var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center pa-4 neutral300"},[_c('v-icon',{staticClass:"mr-4",attrs:{"color":"neutral700"}},[_vm._v("$yzi-markerpin-02")]),_c('div',{staticClass:"text-lg"},[_vm._v(_vm._s(_vm.companyName))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }